import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataLayerService } from '@applications/sha-services';
import { Media } from '@quorum/models/xs-resource';
import { MediaStateService } from '@quorum/sha-media';
import { Observable } from 'rxjs';
import { MediaGalleryDialogComponent } from '../media-gallery-dialog/media-gallery-dialog.component';

@Component({
  selector: 'sha-media-gallery-dialog-button',
  templateUrl: './media-gallery-dialog-button.component.html',
  styleUrls: ['./media-gallery-dialog-button.component.scss'],
})
export class MediaGalleryDialogButtonComponent implements OnInit {
  @Input() media$: Observable<Media[]>;
  @Input() disabled?: boolean;
  @Input() displayText?: boolean;
  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private mediaStateService: MediaStateService,
    public dataLayerService: DataLayerService
  ) {}
  ngOnInit(): void {}

  openMediaDialog() {
    this.mediaStateService.getDeltaMedia();
    const dialogData: any = {
      media$: this.media$,
    };
    const dialogRef = this.dialog.open(MediaGalleryDialogComponent, {
      width: '800px',
      height: '600px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {});
  }
}
